
import { useState } from "react";

import { useNavigate } from "react-router";

import { Grid, Grow, Card, CardActionArea, CardMedia, CardContent, Typography } from "@mui/material"

import { Layout } from "../../components/Layout"

import { DialogCatalogos } from "../../dialogs/DialogCatalogos"

export const AdministracionPage = () => {  
     
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    return (

        <Layout breadcrumbs={[ { text: 'Administración' } ]} backgroundPaper={ false }>

            <Grid container spacing={3}>

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/administracion/usuarios/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    alt={ "catalogos" }
                                    image={ process.env.PUBLIC_URL + '/assets/usuarios.png' }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Usuarios
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid>                 

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => setOpen( true ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    alt={ "catalogos" }
                                    image={ process.env.PUBLIC_URL + '/assets/catalogos.png' }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Catálogos
                                    </Typography>   

                                </CardContent>     

                            </CardActionArea>

                        </Card>

                    </Grow>

                </Grid> 
                       
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/administracion/apikeys/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    alt={ "catalogos" }
                                    image={ process.env.PUBLIC_URL + '/assets/apikeys.png' }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Api Key´s
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid> 

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/administracion/calendario/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    alt={ "catalogos" }
                                    image={ process.env.PUBLIC_URL + '/assets/calendario.png' }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Calendario días inhabiles
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid> 

            </Grid>     

            <DialogCatalogos
                id="catalogos-menu"
                keepMounted
                open={open}
                onClose={ () => setOpen( false ) }
            /> 
            
        </Layout>  
    )
}
